import { render, staticRenderFns } from "./PostDetails.vue?vue&type=template&id=4ac10670"
import script from "./PostDetails.vue?vue&type=script&lang=ts"
export * from "./PostDetails.vue?vue&type=script&lang=ts"
import style0 from "./PostDetails.vue?vue&type=style&index=0&id=4ac10670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports